import React from 'react';
export const WidgetWrapper = ({ children, className = '' }) => {
  return (
    <div
      className={`component component-border-top component-border-right component-border-left widget-wrapper ${className}`.trim()}
    >
      {children}
    </div>
  );
};
